import React from "react"

import SVGIMG from "./svg-img"

export default ({url, img, maxWidth="100%", width="100%"}) => {
  return(
    <SVGIMG src={img} containerMaxWidth={maxWidth} url={url} containerWidth={width} />
  )
}
